import {
  ALLOWED_SITE_LANGUAGES, DEFAULT_LANGUAGE, LOCALE_MAP, getLanguageDisplayName,
} from '../../utils';

/** Served from `public/video`; each site language has a `<base>.<locale>.vtt` beside the MP4. */
export const INTRO_VIDEO_BASE = '/video/Leading-With-Character-Introduction';

export interface IntroVideoTrack {
  src: string;
  srcLang: string;
  label: string;
  kind: 'captions' | 'subtitles';
  isDefault: boolean;
}

export const getIntroVideoTracks = (locale: string): IntroVideoTrack[] => {
  const current = ALLOWED_SITE_LANGUAGES.includes(locale) ? locale : DEFAULT_LANGUAGE;
  return ALLOWED_SITE_LANGUAGES.map((code) => {
    const name = getLanguageDisplayName(LOCALE_MAP[code], current);
    return {
      src: `${INTRO_VIDEO_BASE}.${code}.vtt`,
      srcLang: code,
      label: name.charAt(0).toLocaleUpperCase(current) + name.slice(1),
      kind: code === DEFAULT_LANGUAGE ? 'captions' : 'subtitles',
      isDefault: code === current,
    };
  });
};
